import { requestApi } from 'api/api'
import type { LimitsQueryParams, LimitsResponse } from 'types/paymentLimits'

export const getPaymentLimits = async (params: LimitsQueryParams): Promise<LimitsResponse> => {
  return requestApi({
    url: '/governance/v1/limits',
    method: 'GET',
    params,
  })
}
